// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--1exrD","contentWrapper":"contact-module--contentWrapper--2xOHE","subtitle":"contact-module--subtitle--I-T9J"};